// メッセージMap
export const MessageMap = {
    "case_title": "インターン名",
};
